import { render } from "./AppGarat.vue?vue&type=template&id=b3422a94"
import script from "./AppGarat.vue?vue&type=script&lang=js"
export * from "./AppGarat.vue?vue&type=script&lang=js"

import "./AppGarat.vue?vue&type=style&index=0&id=b3422a94&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__